import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { generatePdf, getRandomString } from 'src/app/utils/utils.common';
import * as moment from "moment-timezone";
import { isiReportDownload } from 'src/app/component/reports/pdf-make-reports/paramount-report';

@Component({
  selector: 'app-report-configuration-modal',
  templateUrl: './report-configuration-modal.component.html',
  styleUrls: ['./report-configuration-modal.component.css']
})
export class ReportConfigurationModalComponent implements OnInit {
  configurationForm: FormGroup
  @Input() selectedTrips: any;
  @Input() user: any;
  @Input() selectedCorporate: any;
  @Input() dataList: any;
  @Input() preSpaceTypes: any;
  @Output() onCloseModal = new EventEmitter<any>();
  trips:any = [];
  paramountLoader = {
    isModal: false,
    isLoading: false,
  };
  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    console.log('selectedTrips', this.selectedTrips);
    this.configurationForm = this.fb.group({
      invoiceNo: [this.generateString()],
      billingCompany: [''],
      billingAddress: [''],
      billingCompanyPhone: [''],
      billingCompanyEmail: [''],
      preInvoiceDate: [moment().toISOString()],
      invoiceDate: [moment().toISOString()],
      dueDate: [moment().toISOString()],
      preDueDate: [moment().add(1,'week').toISOString()],
      outstandingInvoiceNo: [''],
      pastDue: [''],
      corrections: ['']
    })

    if (this.user) {
      this.configurationForm.patchValue({
        billingCompany: this.selectedCorporate.displayName,
        billingAddress: this.selectedCorporate.address,
        billingCompanyPhone: this.selectedCorporate.contactNumber,
        billingCompanyEmail: this.selectedCorporate.email
      })
    }
    this.trips = this.selectedTrips.length ? this.getSelectedTrips() : this.dataList;

  }

  generateString() {
    const randomString = getRandomString(7)
    const dateTime = moment().format('MMDDYY')
    return `${randomString}-${dateTime}`;
  }

  changeInvoiceDate(event) {
    this.configurationForm.patchValue({
      invoiceDate: moment(event).toISOString()
    })

  }
  changeDueDate(event) {
    this.configurationForm.patchValue({
      dueDate: moment(event).toISOString()
    })

  }

  async downloadParaMountReport() {
    this.paramountLoader.isLoading = true;
    this.paramountLoader.isModal = true;
    try {
      const detailsObject = await isiReportDownload(this.trips, this.user,this.configurationForm.value, this.preSpaceTypes, this.selectedCorporate);
      const invoiceName = 'paramount';
      await generatePdf(detailsObject, "download", invoiceName); // <- await important hai
    } catch (err) {
      console.error("Error generating Paramount report:", err);
    } finally {
      this.paramountLoader.isLoading = false;
    }
  }

  closeModal(){
    this.onCloseModal.emit();
  }


  getSelectedTrips() {
    return this.dataList.filter((trip) => trip.isSelected);
  }

}
